import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [formState, setFormState] = useState({ name: '', email: '', message: '' });
  const [isSent, setIsSent] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Contact form submitted:", formState);
    setIsSent(true);
    setFormState({ name: '', email: '', message: '' });
    setTimeout(() => setIsSent(false), 5000);
  };

  return (
    <section id="contact" className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white">Contáctanos</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">
            ¿Tienes alguna pregunta? Estamos aquí para ayudarte.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-secondary dark:text-white mb-6">Envíanos un Mensaje</h3>
            {isSent ? (
               <div className="text-center p-8 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-lg">
                <h3 className="font-bold text-xl">¡Mensaje enviado!</h3>
                <p>Gracias por contactarnos. Te responderemos pronto.</p>
              </div>
            ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Nombre</label>
                <input type="text" name="name" id="name" required value={formState.name} onChange={handleChange} className="mt-1 block w-full px-4 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm focus:ring-primary focus:border-primary" />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
                <input type="email" name="email" id="email" required value={formState.email} onChange={handleChange} className="mt-1 block w-full px-4 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm focus:ring-primary focus:border-primary" />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Mensaje</label>
                <textarea name="message" id="message" rows={5} required value={formState.message} onChange={handleChange} className="mt-1 block w-full px-4 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm focus:ring-primary focus:border-primary"></textarea>
              </div>
              <button 
                type="submit" 
                name="Enviar Mensaje" 
                id="Enviar Mensaje" 
                aria-label="Enviar Mensaje"
                className="w-full bg-primary text-white py-3 px-6 rounded-xl font-bold text-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105">
                Enviar Mensaje
              </button>
            </form>
            )}
          </div>
          <div className="space-y-8">
            <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold text-secondary dark:text-white mb-4">Información de Contacto</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-2"><strong>Dirección:</strong> Calle Falsa 123, Ciudad, País</p>
              <p className="text-gray-600 dark:text-gray-300 mb-2"><strong>Teléfono:</strong> <a href="tel:1234567890" className="text-primary hover:underline">(123) 456-7890</a></p>
              <a 
                href="tel:1234567890" 
                name="Llámanos ahora" 
                id="Llámanos ahora" 
                aria-label="Llámanos ahora"
                className="inline-block mt-2 bg-primary text-white py-2 px-4 rounded-xl font-bold text-sm hover:bg-opacity-90 transition-all duration-300">
                Llámanos ahora
              </a>
              <p className="text-gray-600 dark:text-gray-300 mt-4 mb-2"><strong>Email:</strong> <a href="mailto:contacto@saludintegral.com" className="text-primary hover:underline">contacto@saludintegral.com</a></p>
              <h4 className="font-bold text-lg text-secondary dark:text-white mt-6 mb-2">Horario de Atención</h4>
              <p className="text-gray-600 dark:text-gray-300">Lunes a Viernes: 9:00 - 18:00</p>
              <p className="text-gray-600 dark:text-gray-300">Sábados: 9:00 - 13:00</p>
            </div>
            <div className="bg-gray-300 dark:bg-gray-700 h-64 rounded-lg shadow-lg overflow-hidden">
               <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15885.55394748441!2d-75.58434963579098!3d6.200938341666969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e442838e6f1a9b1%3A0x1137063d3301a355!2sParque%20El%20Poblado!5e0!3m2!1ses!2sco!4v1646247290952!5m2!1ses!2sco"
                  width="100%"
                  height="100%"
                  style={{ border: '0' }}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación de la Clínica Salud Integral"
                ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;